import {useState, useEffect} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import Member from '../Assessment/Member'
import ProfilePana from '../Assessment/ProfilePana'
import Note from '../Assessment/Note'
import History from '../Assessment/History'
import BackButton from './BackButton'
import {useParams} from 'react-router-dom'
import IndicatorAssessmentInterview from './IndicatorAssessmentInterview'
import TypeProposal from '../Assessment/TypeProposal'
import ProposalSummary from '../Assessment/ProposalSummary'
const api = new Api()

const DetailPage = () => {
  const {id} = useParams()
  const [data, setData] = useState<any>([])
  const [errors, setErrors] = useState<any>({})
  const [logs, setLogs] = useState<any>([])

  useEffect(() => {
    fetchData(id)
    getDetailLog(id)
  }, [])

  const handleInput = (name: any, value: any) => {
  }

  const fetchData = (id: any) => {
    api
      .getDetailAdminInterview(id)
      .then((response: any) => {
        const data = response.data.data
        setData(data)
      })
      .catch((error: any) => {
      })
  }

  const getDetailLog = (id: any) => {
    api
      .getDetailLog(id)
      .then((response: any) => {
        const data = response.data.data
        setLogs(data?.logs)
      })
      .catch((error: any) => {
      })
  }

  const handleReloadData = (isReload: boolean) => {
    if (isReload == false) {
      return
    }

    fetchData(id)
  }

  return (
    <div className='row'>
      <div className='col-md-12'>
        <BackButton to='/monitoring' />
      </div>

      <div className='col-md-12 px-6 mt-8'>
        <ProfilePana data={data?.pendaftaran} />
      </div>

      <div className='col-md-12 mt-8'>
        <Member data={data?.pendaftaran} allowEdit={true} reloadData={handleReloadData} />
      </div>

      <div className='col-md-12 mt-8'>
        <div className='card'>
          <div className='px-8 py-7'>
            <div className='d-flex align-items-center gap-3'>
              <p className='fs-4 fw-bold'>Tema Essay Utama</p>
            </div>
          </div>
          <div className='px-8 pb-8'>
            <div className='p-5 border rounded-top' style={{backgroundColor: '#F4F7FE'}}>
              <p className='mb-0'>Tema Essay</p>
            </div>
            <div className='p-5 border'>
              <p className='mb-0'>{data?.pendaftaran?.judul_proposal || '-'}</p>
            </div>
          </div>
        </div>
      </div>

      <div className='col-md-12 mt-8'>
        <ProposalSummary
          title='Ringkasan Proposal Utama'
          value={data?.pendaftaran?.ringkasan_proposal}
        />
      </div>

      {data?.pendaftaran?.anggota?.length > 0 && (
        <>
          <div className='col-md-12 mt-8'>
            <div className='card'>
              <div className='px-8 py-7'>
                <div className='d-flex align-items-center gap-3'>
                  <p className='fs-4 fw-bold'>Tema Essay Kedua</p>
                </div>
              </div>
              <div className='px-8 pb-8'>
                <div className='p-5 border rounded-top' style={{backgroundColor: '#F4F7FE'}}>
                  <p className='mb-0'>Tema Essay</p>
                </div>
                <div className='p-5 border'>
                  <p className='mb-0'>{data?.pendaftaran?.judul_proposal_2 || '-'}</p>
                </div>
              </div>
            </div>
          </div>

          <div className='col-md-12 mt-8'>
            <ProposalSummary
              title='Ringkasan Proposal Kedua'
              value={data?.pendaftaran?.ringkasan_proposal_2}
            />
          </div>
        </>
      )}

      <div className='col-md-12 mt-8'>
        <TypeProposal
          radioButton={false}
          title='Dokumen'
          data={data?.pendaftaran}
          handleInput={handleInput}
          dataFile={data}
          isAdmin={true}
          errors={{}}
          fieldRefs={{}}
        />
      </div>

      <div className='col-md-12 mt-8'>
        <IndicatorAssessmentInterview data={data?.wawancara} title='Wawancara' />
      </div>

      <div className='col-md-12 mt-8'>
        <Note
          name='catatan'
          title='Catatan Penilaian'
          handleInput={handleInput}
          defaultValue={''}
          readOnly={true}
          defaultDataNote={data?.wawancara}
          errors={{}}
        />
      </div>

      <div className='col-md-12 mt-8'>
        <History logs={logs} />
      </div>
    </div>
  )
}

const Detail = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Detail Nilai Proposal
      </PageTitle>
      <DetailPage />
    </>
  )
}

export default Detail
